import { PrestationCode } from '../../prestation-code/prestation-code.model';
import { Pagination } from '../pagination.model';

export class PrestationCodePage extends Pagination {
  content: PrestationCode[] = [];
}
